<ng-container *transloco="let t; read: 'expenses'">
  <kendo-dialog [title]="t(titleKey)" (close)="onCancel()" [width]="450" [maxWidth]="'95vw'">
    <form [formGroup]="formGroup" class="flex-col">
      <kendo-label [text]="t('rejectionReason')"></kendo-label>
      <kendo-textarea formControlName="reason" [rows]="4" resizable="vertical"></kendo-textarea>
    </form>

    <kendo-dialog-actions>
      <button kendoButton (click)="onCancel()">{{ t('cancel') }}</button>
      <button kendoButton themeColor="primary" [disabled]="formGroup.invalid" (click)="onConfirm()">
        {{ t(confirmKey) }}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
</ng-container>
